import { render, staticRenderFns } from "./SubComponentContainer.vue?vue&type=template&id=56042c83"
import script from "./SubComponentContainer.vue?vue&type=script&lang=js"
export * from "./SubComponentContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports